import '../../node_modules/.pnpm/@ant-design_cssinjs@1.23.0_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/cssinjs/es/extractStyle.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/objectSpread2';
import 'react';
import '../../node_modules/.pnpm/@ant-design_cssinjs@1.23.0_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/cssinjs/es/StyleContext.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/createSuper';
import '../../node_modules/.pnpm/@ant-design_cssinjs@1.23.0_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/cssinjs/es/theme/createTheme.js';
import '../../node_modules/.pnpm/rc-util@5.44.4_react-dom@18.3.1_react@18.3.1/node_modules/rc-util/es/warning.js';
import '../../node_modules/.pnpm/@ant-design_cssinjs@1.23.0_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/cssinjs/es/theme/ThemeCache.js';
import '../../node_modules/.pnpm/@ant-design_cssinjs@1.23.0_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js';
import '../../node_modules/.pnpm/@ant-design_cssinjs@1.23.0_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js';
import useStyleRegister from '../../node_modules/.pnpm/@ant-design_cssinjs@1.23.0_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/cssinjs/es/hooks/useStyleRegister.js';
import '../../node_modules/.pnpm/@ant-design_cssinjs@1.23.0_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js';
import { alertStyleFn } from '../../alert/style/styleConfig.js';
import { appStyleFn } from '../../app/style/styleConfig.js';
import { buttonStyleFn } from '../../button/style/styleConfig.js';
import { cascaderStyleFn } from '../../cascader/style/styleConfig.js';
import { checkboxStyleFn } from '../../checkbox/style/styleConfig.js';
import { datePickerStyleFn } from '../../date-picker/style/styleConfig.js';
import { dividerStyleFn } from '../../divider/style/styleConfig.js';
import { drawerStyleFn } from '../../drawer/style/styleConfig.js';
import { dropdownStyleFn } from '../../dropdown/style/styleConfig.js';
import { formStyleFn } from '../../form/style/styleConfig.js';
import { inputStyleFn } from '../../input/style/styleConfig.js';
import { inputNumberStyleFn } from '../../input-number/style/styleConfig.js';
import { menuStyleFn } from '../../menu/style/styleConfig.js';
import { paginationStyleFn } from '../../pagination/style/styleConfig.js';
import { popoverStyleFn } from '../../popover/style/styleConfig.js';
import { radioStyleFn } from '../../radio/style/styleConfig.js';
import { selectStyleFn } from '../../select/style/styleConfig.js';
import { sliderStyleFn } from '../../slider/style/styleConfig.js';
import { spinStyleFn } from '../../spin/style/styleConfig.js';
import { stepsStyleFn } from '../../steps/style/styleConfig.js';
import { switchStyleFn } from '../../switch/style/styleConfig.js';
import { tableStyleFn } from '../../table/style/styleConfig.js';
import { tabsStyleFn } from '../../tabs/style/styleConfig.js';
import { tagStyleFn } from '../../tag/style/styleConfig.js';
import { theme } from 'antd';
import { timePickerStyleFn } from '../../time-picker/style/styleConfig.js';
import { timelineStyleFn } from '../../timeline/style/styleConfig.js';
import { treeSelectStyleFn } from '../../tree-select/style/styleConfig.js';
import { uploadStyleFn } from '../../upload/style/styleConfig.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var useStyle = function useStyle(currentTheme) {
  // console.log('currentTheme', currentTheme);
  var token = currentTheme.token,
    componentToken = currentTheme.components;
  var btnToken = _extends({}, currentTheme.token, componentToken == null ? void 0 : componentToken.Button);
  var alertToken = _extends({}, currentTheme.token, componentToken == null ? void 0 : componentToken.Alert);
  // const breadcrumbToken = { ...currentTheme.token, ...componentToken.Breadcrumb };
  var cascaderToken = _extends({}, currentTheme.token, componentToken.Cascader);
  var checkboxToken = _extends({}, currentTheme.token, componentToken.Checkbox);
  var datePickerToken = _extends({}, currentTheme.token, componentToken.DatePicker);
  var dividerToken = _extends({}, currentTheme.token, componentToken.Divider);
  var drawerToken = _extends({}, currentTheme.token, componentToken.Drawer);
  var dropdownToken = _extends({}, currentTheme.token, componentToken.Dropdown);
  var formToken = _extends({}, currentTheme.token, componentToken.FormToken);
  var inputToken = _extends({}, currentTheme.token, componentToken.Input);
  var inputNumberToken = _extends({}, currentTheme.token, componentToken.InputNumber);
  var menuToken = _extends({}, currentTheme.token, componentToken.Menu);
  var paginationToken = _extends({}, currentTheme.token, componentToken.Pagination);
  var popoverToken = _extends({}, currentTheme.token, componentToken.Popover);
  var radioToken = _extends({}, currentTheme.token, componentToken.Radio);
  var selectToken = _extends({}, currentTheme.token, componentToken.Select);
  _extends({}, currentTheme.token, componentToken.Slider);
  var spinToken = _extends({}, currentTheme.token, componentToken.Spin);
  var stepsToken = _extends({}, currentTheme.token, componentToken.Steps);
  _extends({}, currentTheme.token, componentToken.Switch);
  var tableToken = _extends({}, currentTheme.token, componentToken.Table);
  var tabsToken = _extends({}, currentTheme.token, componentToken.Tabs);
  var tagToken = _extends({}, currentTheme.token, componentToken.Tag);
  _extends({}, currentTheme.token, componentToken.DatePicker);
  var timelineToken = _extends({}, currentTheme.token, componentToken.Timeline);
  // const tooltipToken = { ...currentTheme.token, ...componentToken.Tooltip };
  _extends({}, currentTheme.token, componentToken.TreeSelect);
  var uploadToken = _extends({}, currentTheme.token, componentToken.Upload);
  var appToken = _extends({}, currentTheme.token, componentToken.App);
  var antPrefixCls = '.ant';
  var pebblePrefixCls = '.pebble';
  var _Theme$useToken = theme.useToken(),
    theme$1 = _Theme$useToken.theme;
  return useStyleRegister({
    theme: theme$1,
    token: token,
    path: ['pebble-provider']
  }, function () {
    var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12;
    return [
    // alert
    alertStyleFn(alertToken)].concat(buttonStyleFn(btnToken), [
    //cascader
    cascaderStyleFn(cascaderToken),
    //checkbox
    checkboxStyleFn(checkboxToken)], datePickerStyleFn(datePickerToken), [
    //divider
    dividerStyleFn(dividerToken),
    //drawer
    drawerStyleFn(drawerToken),
    //dropdown
    dropdownStyleFn(dropdownToken),
    //form
    formStyleFn(formToken)], inputStyleFn(inputToken), inputNumberStyleFn(inputNumberToken), [
    //menu
    menuStyleFn(menuToken),
    //pagination
    paginationStyleFn(paginationToken),
    //popover
    popoverStyleFn(popoverToken)], radioStyleFn(radioToken), selectStyleFn(selectToken), sliderStyleFn(), [
    //spin
    spinStyleFn(spinToken),
    //steps
    stepsStyleFn(stepsToken),
    //switch
    switchStyleFn()], tableStyleFn(tableToken), tabsStyleFn(tabsToken), tagStyleFn(tagToken), [
    //timeline
    timelineStyleFn(timelineToken), (_ref2 = {}, _ref2[antPrefixCls + "-notification .ant-notification-notice-wrapper"] = (_ref = {
      borderRadius: '16px',
      '.ant-notification-notice-message': {
        fontWeight: '600'
      },
      '.ant-notification-notice-close': {
        color: token.colorTextSecondary
      },
      '.ant-notification-notice-with-icon': {
        '.ant-notification-notice-description,.ant-notification-notice-message': {
          marginInlineStart: 28
        }
      },
      '.ant-notification-notice-icon': {
        fontSize: 20
      }
    }, _ref[antPrefixCls + "-notification-notice-icon-info.anticon"] = {
      color: token.colorPrimary
    }, _ref[pebblePrefixCls + "-btn" + antPrefixCls + "-btn-primary"] = {
      backgroundColor: btnToken.colorPrimary
    }, _ref[antPrefixCls + "-btn-link"] = {
      color: btnToken.colorPrimary
    }, _ref), _ref2),
    //tooltip
    {
      '.ant-tooltip .ant-tooltip-arrow::before': {
        clipPath: "path('M 0 8 A 4 4 0 0 0 2.828 6.828 L 6.585 3.071 A 2 2 0 0 1 9.414 3.071 L 13.171 6.828 A 4 4 0 0 0 16 8 Z') !important"
      },
      '.ant-tooltip .ant-tooltip-inner': {
        padding: '6px 12px'
      }
    },
    //treeSelect
    treeSelectStyleFn(),
    //upload
    uploadStyleFn(uploadToken),
    //app
    appStyleFn(appToken), (_ref9 = {}, _ref9[antPrefixCls + "-modal"] = (_ref3 = {
      fontFamily: token.fontFamily + " !important",
      '.ant-modal-confirm-btns .ant-btn': {
        fontFamily: token.fontFamily + " !important"
      }
    }, _ref3[antPrefixCls + "-modal-header"] = {
      marginBottom: '12px'
    }, _ref3[".ant-modal-close"] = {
      height: '24px',
      width: '24px',
      '&:active': {
        color: token.colorText
      }
    }, _ref3[antPrefixCls + "-modal-body"] = {
      color: token.colorTextSecondary
    }, _ref3[antPrefixCls + "-modal-content"] = {
      padding: '20px 20px',
      borderRadius: '16px'
    }, _ref3[antPrefixCls + "-modal-footer"] = {
      marginTop: '16px'
      // '.ant-btn-primary': {
      //   minWidth: '76px',
      // },
    }, _ref3), _ref9[antPrefixCls + "-modal-mask"] = {
      // 统一modal mask 颜色
      backgroundColor: 'rgba(3, 4, 5, 0.6) !important'
    }, _ref9[antPrefixCls + "-modal" + antPrefixCls + "-modal-confirm"] = (_ref8 = {}, _ref8[antPrefixCls + "-modal-title"] = {
      fontSize: token.fontSizeLG + "px"
    }, _ref8[antPrefixCls + "-modal-body"] = (_ref4 = {}, _ref4[antPrefixCls + "-modal-confirm-content"] = {
      // 文字内容颜色 color-grey-8
      color: "" + token.colorTextSecondary
    }, _ref4['.ant-modal-confirm-body >.anticon'] = {
      marginInlineEnd: '8px',
      fontSize: '20px'
    }, _ref4), _ref8['.ant-modal-confirm-paragraph'] = {
      rowGap: 12
    }, _ref8[".ant-modal-confirm-btns"] = {
      marginTop: 16
    }, _ref8["&" + antPrefixCls + "-modal-confirm-info"] = (_ref5 = {}, _ref5[antPrefixCls + "-modal-confirm-body>.anticon"] = {
      color: token.colorPrimary
    }, _ref5), _ref8[antPrefixCls + "-btn"] = (_ref6 = {}, _ref6["&:not(" + antPrefixCls + "-btn-icon-only)"] = {
      //不影响设置icon的按钮
      // OK按钮宽度76px（和Cancel一样，最小按钮宽度）
      // minWidth: '76px',
    }, _ref6), _ref8[antPrefixCls + "-btn-default:hover"] = {
      color: btnToken.defaultHoverColor,
      borderColor: btnToken.defaultHoverBorderColor
    }, _ref8[antPrefixCls + "-btn-default:active"] = {
      borderColor: btnToken.defaultActiveBorderColor,
      color: btnToken.defaultActiveColor
    }, _ref8[antPrefixCls + "-btn-primary"] = (_ref7 = {
      backgroundColor: btnToken.colorPrimary,
      // 去掉阴影
      boxShadow: 'none'
    }, _ref7['&:not(:disabled):hover'] = {
      backgroundColor: btnToken.colorPrimaryHover
    }, _ref7['&:not(:disabled):active'] = {
      backgroundColor: btnToken.colorPrimaryActive
    }, _ref7), _ref8), _ref9), (_ref0 = {}, _ref0[antPrefixCls + "-message"] = {
      '.ant-message-notice .ant-message-loading .anticon': {
        color: token.colorPrimaryText
      }
    }, _ref0['.ant-message .ant-message-notice-wrapper .ant-message-notice-content'] = {
      padding: '12px 20px',
      color: token.colorWhite,
      background: '#000'
    }, _ref0),
    // breadcrumb
    {
      '.ant-breadcrumb a:hover': {
        backgroundColor: 'transparent'
      },
      '.ant-breadcrumb .ant-breadcrumb-overlay-link:hover': {
        backgroundColor: 'transparent'
      }
    }, (_ref10 = {
      '.ant-descriptions .ant-descriptions-row >th': {
        padding: '0 20px 7px 0'
      },
      '.ant-descriptions .ant-descriptions-row >td': {
        paddingBottom: 28
      },
      '.ant-empty .ant-empty-image': {
        height: '64px'
      },
      '.ant-badge .ant-badge-count': {
        boxShadow: 'none'
      },
      '.ant-rate': {
        color: token.colorPrimary,
        '.ant-rate-star-second': {
          color: token.colorFill
        }
      }
    }, _ref10[antPrefixCls + "-avatar"] = (_ref1 = {}, _ref1['&&-lg&-icon'] = {
      fontSize: '24px'
    }, _ref1), _ref10['.ant-collapse>.ant-collapse-item'] = {
      '>.ant-collapse-header': {
        padding: '9px 20px',
        fontWeight: '600',
        alignItems: 'center'
      }
    }, _ref10['.ant-collapse .ant-collapse-content'] = {
      borderTop: "1px solid " + token.colorTextQuaternary
    }, _ref10['.ant-tour-description'] = {
      color: token.colorTextSecondary
    }, _ref10)], timePickerStyleFn(), [(_ref12 = {}, _ref12[antPrefixCls + "-picker-time-panel-column"] = (_ref11 = {}, _ref11['&::-webkit-scrollbar'] = {
      backgroundColor: token.colorWhite,
      width: '8px'
    }, _ref11['&::-webkit-scrollbar-thumb'] = {
      backgroundColor: token.colorBorder,
      borderRadius: '8px'
    }, _ref11['&::-webkit-scrollbar-thumb:hover'] = {
      backgroundColor: token.colorInfoTextHover
    }, _ref11), _ref12)]);
  });
};

export { useStyle as default };
